var map = {
	"./svg/coupon.svg": 67422,
	"./svg/member.svg": 70008,
	"./svg/msg.svg": 22217,
	"./svg/org.svg": 15743,
	"./svg/product.svg": 16967,
	"./svg/store.svg": 78149,
	"./svg/sysconfig.svg": 60060,
	"./svg/专业课程.svg": 30136,
	"./svg/分类.svg": 82816,
	"./svg/商品分类.svg": 82353,
	"./svg/商品列表.svg": 40161,
	"./svg/商城管理.svg": 36049,
	"./svg/回访管理.svg": 52742,
	"./svg/复诊管理.svg": 16939,
	"./svg/学籍4.svg": 1655,
	"./svg/定时任务.svg": 33001,
	"./svg/客户管理.svg": 67387,
	"./svg/录音管理.svg": 50711,
	"./svg/数据中心.svg": 36732,
	"./svg/文件.svg": 74851,
	"./svg/文档.svg": 75700,
	"./svg/文档列表.svg": 62117,
	"./svg/日志记录.svg": 25315,
	"./svg/权限.svg": 81140,
	"./svg/案例图片.svg": 86175,
	"./svg/治疗管理.svg": 69661,
	"./svg/用户列表.svg": 46101,
	"./svg/用户卡券.svg": 75155,
	"./svg/短信服务.svg": 38542,
	"./svg/短信模版.svg": 5537,
	"./svg/短信群发.svg": 71853,
	"./svg/短信记录.svg": 95594,
	"./svg/章节.svg": 6658,
	"./svg/考试.svg": 18747,
	"./svg/自助预约.svg": 36832,
	"./svg/菜单.svg": 96269,
	"./svg/规格.svg": 437,
	"./svg/角色.svg": 36058,
	"./svg/课时练习.svg": 67121,
	"./svg/课程列表.svg": 58055,
	"./svg/课程管理.svg": 26934,
	"./svg/账号.svg": 95947,
	"./svg/资金明细.svg": 19850,
	"./svg/部门.svg": 4490,
	"./svg/院内管理.svg": 80050,
	"./svg/预约管理.svg": 37595,
	"./svg/题库.svg": 77846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52064;